import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { ReplaySubject, throwError } from "rxjs";
import { take } from "rxjs/operators";
import { SessionService } from "./services/session.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private _sessionService: SessionService,
        private _router: Router,
        private _location: Location
    ) { }

    canActivate() {
        let subject = new ReplaySubject<boolean | UrlTree>(1);
        this._sessionService.tryLogin().pipe(take(1)).subscribe({
            next: (value) => subject.next(true),
            error: (error) => {
                this._router.navigateByUrl(this._router.createUrlTree(['/login'], {
                    'queryParams': {
                        'redirect': this._location.path()
                    }
                }));
                return throwError(error);
            }
        });
        return subject.asObservable();
    }

}